import MuiChip, { ChipProps as MuiChipProps } from '@mui/material/Chip';
import CloseIcon from '@mui/icons-material/Close';
import type { ReactNode } from 'react';

export type ChipVariant = 'primary' | 'secondary' | 'warning' | 'neutral';
export type ChipStyle = 'filled' | 'outlined';

export type ChipProps = {
  label: string;
  /** Visual palette variant (mapped to theme colors). */
  variant?: ChipVariant;
  /** Filled or outlined look. @default 'filled' */
  chipStyle?: ChipStyle;
  size?: 'small' | 'medium';
  disabled?: boolean;
  /** Optional icon node only (e.g. `<CheckIcon />`). */
  icon?: ReactNode;
  /** Show delete affordance. */
  deletable?: boolean;
  onClick?: () => void;
} & Pick<MuiChipProps, 'onDelete'>;

export function Chip({
  label,
  variant = 'primary',
  chipStyle = 'filled',
  size = 'medium',
  disabled = false,
  icon,
  deletable = false,
  onDelete,
  onClick
}: ChipProps) {
  const className = [
    'SmChip-root',
    deletable ? 'SmChip-deletable' : null,
    `SmChip-variant-${variant}`,
    `SmChip-style-${chipStyle}`
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <MuiChip
      className={className}
      label={label}
      size={size}
      disabled={disabled}
      icon={icon ? <span className="SmChip-icon">{icon}</span> : undefined}
      onClick={onClick}
      deleteIcon={deletable ? <CloseIcon /> : undefined}
      onDelete={deletable ? onDelete ?? (() => undefined) : undefined}
      clickable={Boolean(onClick)}
    />
  );
}
